import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';

import { MessageService, ButtonLoader } from '../../../../core';
import { ClienteAnaliseMercadoLancamentoFormComponent } from '../form';
import { ClienteAnaliseMercadoPerspectiva } from '../../perspectivas/cliente-analise-mercado-perspectiva';

@Component({
    selector: 'sgt-cliente-analise-mercado-lancamento-form-modal',
    templateUrl: './cliente-analise-mercado-lancamento-form-modal.component.html',
    styleUrls: ['./cliente-analise-mercado-lancamento-form-modal.component.less']
})
export class ClienteAnaliseMercadoLancamentoFormModalComponent implements OnInit {
    perspectiva: ClienteAnaliseMercadoPerspectiva;
    idCliente: number;
    ano: number;
    idClienteAnaliseMercadoClassificacao: number;
    idGrupoClassificacao: number;
    idsClassificacoes: number[];
    criarSeNaoEncontrar: boolean;

    elModal: any;
    /** Se o modal está aberto */
    isOpen = false;
    /** Se pode editar o form */
    canEdit: boolean;

    @ViewChild('form') form: ClienteAnaliseMercadoLancamentoFormComponent;
    @ViewChild('btnSave') btnSave: ElementRef;
    @Output() afterSave = new EventEmitter<void>();
    @Output() afterCancel = new EventEmitter<void>();

    constructor(private el: ElementRef,
                private messageService: MessageService) { }

    ngOnInit() {
        this.create();
    }

    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.isOpen = true;
                setTimeout(() => this.form?.load(this.perspectiva?.id ?? null, this.idCliente, this.ano, this.idClienteAnaliseMercadoClassificacao, this.idGrupoClassificacao, this.idsClassificacoes, this.criarSeNaoEncontrar), 0);
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.isOpen = false;
                e.stopPropagation();
            });
    }

    /** Abre o modal */
    open(perspectiva: ClienteAnaliseMercadoPerspectiva, idCliente: number, ano: number, idClienteAnaliseMercadoClassificacao: number, idGrupoClassificacao: number, idsClassificacoes: number[], criarSeNaoEncontrar: boolean, canEdit: boolean) {
        this.perspectiva = perspectiva;
        this.idCliente = idCliente;
        this.ano = ano;
        this.idClienteAnaliseMercadoClassificacao = idClienteAnaliseMercadoClassificacao;
        this.idGrupoClassificacao = idGrupoClassificacao;
        this.idsClassificacoes = idsClassificacoes;
        this.criarSeNaoEncontrar = criarSeNaoEncontrar;
        this.canEdit = canEdit;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Limpa as variáveis do modal */
    private clear() {
        this.perspectiva = null;
        this.idCliente = null;
        this.ano = null;
        this.idClienteAnaliseMercadoClassificacao = null;
        this.idGrupoClassificacao = null;
        this.idsClassificacoes = null
        this.criarSeNaoEncontrar = null;
    }

    /** Fecha o modal */
    close() {
        this.clear();
        this.elModal.modal('hide');
    }

    /** Cancela as alterações nas projeções de vendas mensais do cliente */
    cancel() {
        this.messageService.confirm('Deseja realmente cancelar suas alterações feitas neste lançamento?', 'Confirme').then(result => {
            if (result) {
                this.afterCancel.emit();
                this.close();
            }
        });
    }

    /** Salva o lançamento da classificação na análise de mercado */
    async save() {
        const btn = new ButtonLoader(this.btnSave.nativeElement);

        try {
            btn.loading('Salvando');
            await this.form?.save();
            this.afterSave.emit();
            btn.reset();
            this.close();
        } catch (error) {
            console.error(error);
            btn.reset();
        }
    }
}
